import { render, staticRenderFns } from "./SendSolicitud.vue?vue&type=template&id=7473d2b0&scoped=true"
import script from "./SendSolicitud.vue?vue&type=script&lang=js"
export * from "./SendSolicitud.vue?vue&type=script&lang=js"
import style0 from "./SendSolicitud.vue?vue&type=style&index=0&id=7473d2b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7473d2b0",
  null
  
)

export default component.exports